import axios from 'axios';

const rawUrl = process.env.REACT_APP_API_URL || `${window.location.origin}`;
const baseUrl = rawUrl.endsWith('/api') ? rawUrl : `${rawUrl}/api`.replace(/\/\//g, '/').replace(':/', '://');
export const getNeighborhoodDevelopments = async () => {
  try {
    const response = await axios.get(`${baseUrl}/NeighborhoodDevelopment/All`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const getNeighborhoodDevelopmentByGuid = async (guid) => {
  try {
    const response = await axios.post(`${baseUrl}/NeighborhoodDevelopment/GetByGuid`, { guid });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};
